export const loincHeadCells = [
  {
    id: "loincCode",
    numeric: true,
    disablePadding: false,
    label: "LOINC Code",
  },
  {
    id: "loincShortName",
    numeric: true,
    disablePadding: false,
    label: "LOINC Short Name",
  },
  {
    id: "conditionName",
    numeric: true,
    disablePadding: false,
    label: "Condition",
  },
  {
    id: "testMethod",
    numeric: true,
    disablePadding: false,
    label: "Test Method",
  },
  {
    id: "isActive",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "specimenSource",
    numeric: true,
    disablePadding: false,
    label: "Specimen Source",
  },
  {
    id: "scaleType",
    numeric: true,
    disablePadding: false,
    label: "Scale Type",
  },
  {
    id: "codeSystem",
    numeric: true,
    disablePadding: false,
    label: "Code System",
  },
];

export const aoeLoincHeadCells = [
  {
    id: "aoeLoincCode",
    numeric: true,
    disablePadding: false,
    label: "LOINC Code",
  },
  {
    id: "aoeLoincLongName",
    numeric: true,
    disablePadding: false,
    label: "LOINC Long Name",
  },
  {
    id: "description",
    numeric: true,
    disablePadding: false,
    label: "Description",
  },
  {
    id: "responseDatatype",
    numeric: true,
    disablePadding: false,
    label: "Response Data Type",
  },
  {
    id: "valueSetName",
    numeric: true,
    disablePadding: false,
    label: "Value Set Name",
  },
  {
    id: "isActive",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "comments",
    numeric: true,
    disablePadding: false,
    label: "Admin Comments",
  },
];

export const rulesScreenLoincCodes = [
  {
    id: "loincCode",
    numeric: true,
    disablePadding: false,
    label: "LOINC Code",
  },
  {
    id: "loincLongName",
    numeric: true,
    disablePadding: false,
    label: "Test Performed LOINC Long Name",
  },
  {
    id: "loincShortName",
    numeric: true,
    disablePadding: false,
    label: "LOINC Short Name",
  },
  {
    id: "conditionName",
    numeric: true,
    disablePadding: false,
    label: "Condition",
  },
  {
    id: "testMethod",
    numeric: true,
    disablePadding: false,
    label: "Test Method",
  },
];

export const rulesScreenSnomedCodes = [
  {
    id: "snomedCode",
    numeric: true,
    disablePadding: false,
    label: "SNOMED Code",
  },
  {
    id: "secondarySnomed",
    numeric: false,
    disablePadding: false,
    label: "Secondary SNOMED",
  },
  {
    id: "conceptName",
    numeric: true,
    disablePadding: false,
    label: "Preferred Concept Name",
  },
  {
    id: "conditionName",
    numeric: false,
    disablePadding: false,
    label: "Master Condition",
  },
  {
    id: "snomedType",
    numeric: false,
    disablePadding: false,
    label: "SNOMED Type",
  },
];

export const errorMesageQueueHeadCells = [
  {
    id: "qaFlag",
    numeric: false,
    disablePadding: false,
    label: "",
  },
  {
    id: "transactionId",
    numeric: false,
    disablePadding: false,
    label: "Identifier",
  },
  {
    id: "msh10",
    numeric: true,
    disablePadding: false,
    label: "Message Control ID",
  },
  {
    id: "specimen",
    numeric: true,
    disablePadding: false,
    label: "Specimen ID",
  },
  {
    id: "transactionReceivedDate",
    numeric: true,
    disablePadding: false,
    label: "Time Received",
  },
  {
    id: "sendingFacilityName",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility",
  },
  {
    id: "sendingFacility",
    numeric: true,
    disablePadding: false,
    label: "CLIA",
  },
  {
    id: "conditions",
    numeric: true,
    disablePadding: false,
    label: "Conditions",
  },
  {
    id: "transactionError",
    numeric: true,
    disablePadding: false,
    label: "Error Type",
  },
];

export const unknownFacilityQueueHeadCells = [
  {
    id: "qaFlag",
    numeric: false,
    disablePadding: false,
    label: "",
  },
  {
    id: "transactionId",
    numeric: false,
    disablePadding: false,
    label: "Identifier",
  },
  {
    id: "msh10",
    numeric: true,
    disablePadding: false,
    label: "Message Control ID",
  },
  {
    id: "specimen",
    numeric: true,
    disablePadding: false,
    label: "Specimen ID",
  },
  {
    id: "transactionReceivedDate",
    numeric: true,
    disablePadding: false,
    label: "Time Received",
  },
  {
    id: "sendingFacilityName",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility",
  },
  {
    id: "npi",
    numeric: true,
    disablePadding: false,
    label: "CLIA",
  },
  {
    id: "transactionError",
    numeric: true,
    disablePadding: false,
    label: "Error Type",
  },
];

export const duplicateQueueHeadCells = [
  {
    id: "qaFlag",
    numeric: false,
    disablePadding: false,
    label: "",
  },
  {
    id: "transactionId",
    numeric: false,
    disablePadding: false,
    label: "Identifier",
  },
  {
    id: "msh10",
    numeric: true,
    disablePadding: false,
    label: "Message Control ID",
  },
  {
    id: "specimen",
    numeric: true,
    disablePadding: false,
    label: "Specimen ID",
  },
  {
    id: "transactionReceivedDate",
    numeric: true,
    disablePadding: false,
    label: "Time Received",
  },
  {
    id: "sendingFacilityName",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility",
  },
  {
    id: "sendingFacility",
    numeric: true,
    disablePadding: false,
    label: "CLIA",
  },
  {
    id: "transactionError",
    numeric: true,
    disablePadding: false,
    label: "Error Type",
  },
];


export const eICRErrorQueueHeadCells = [
  {
    id: "qaFlag",
    numeric: false,
    disablePadding: false,
    label: "",
  },
  {
    id: "transactionId",
    numeric: false,
    disablePadding: false,
    label: "Identifier",
  },
  {
    id: "msh10",
    numeric: true,
    disablePadding: false,
    label: "Message Control ID",
  },
  {
    id: "specimen",
    numeric: true,
    disablePadding: false,
    label: "Specimen ID",
  },
  {
    id: "transactionReceivedDate",
    numeric: true,
    disablePadding: false,
    label: "Time Received",
  },
  {
    id: "sendingFacilityName",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility",
  },
  {
    id: "sendingFacility",
    numeric: true,
    disablePadding: false,
    label: "CLIA",
  },
  {
    id: "transactionError",
    numeric: true,
    disablePadding: false,
    label: "Error Type",
  },
];

export const discardQueueHeadCells = [
  {
    id: "qaFlag",
    numeric: false,
    disablePadding: false,
    label: "",
  },
  {
    id: "transactionId",
    numeric: false,
    disablePadding: false,
    label: "Identifier",
  },
  {
    id: "msh10",
    numeric: true,
    disablePadding: false,
    label: "Message Control ID",
  },
  {
    id: "specimen",
    numeric: true,
    disablePadding: false,
    label: "Specimen ID",
  },
  {
    id: "transactionReceivedDate",
    numeric: true,
    disablePadding: false,
    label: "Time Received",
  },
  {
    id: "sendingFacilityName",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility",
  },
  {
    id: "sendingFacility",
    numeric: true,
    disablePadding: false,
    label: "CLIA",
  },
  {
    id: "conditions",
    numeric: true,
    disablePadding: false,
    label: "Conditions",
  },
  {
    id: "transactionError",
    numeric: true,
    disablePadding: false,
    label: "Error Type",
  },
];

export const eicrDiscardQueueHeadCells = [
  {
    id: "qaFlag",
    numeric: false,
    disablePadding: false,
    label: "",
  },
  {
    id: "transactionId",
    numeric: false,
    disablePadding: false,
    label: "Identifier",
  },
  {
    id: "msh10",
    numeric: true,
    disablePadding: false,
    label: "Message Control ID",
  },
  {
    id: "transactionReceivedDate",
    numeric: true,
    disablePadding: false,
    label: "Time Received",
  },
  {
    id: "sendingFacilityName",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility",
  },
  {
    id: "SendingFacilityidORcliaORoidORNPI",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility ID",
  },
  {
    id: "transactionError",
    numeric: true,
    disablePadding: false,
    label: "Error Type",
  },
];

export const masterQueueHeadCells = [
  {
    id: "qaFlag",
    numeric: false,
    disablePadding: false,
    label: "",
  },
  {
    id: "transactionId",
    numeric: false,
    disablePadding: false,
    label: "Identifier",
  },
  {
    id: "msh10",
    numeric: true,
    disablePadding: false,
    label: "Message Control ID",
  },
  {
    id: "specimen",
    numeric: true,
    disablePadding: false,
    label: "Specimen ID",
  },
  {
    id: "transactionReceivedDate",
    numeric: true,
    disablePadding: false,
    label: "Time Received",
  },
  {
    id: "transactionProcessedDate",
    numeric: true,
    disablePadding: false,
    label: "Time Processed",
  },
  {
    id: "sendingFacilityName",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility",
  },
  {
    id: "conditions",
    numeric: true,
    disablePadding: false,
    label: "Conditions",
  },
  {
    id: "sendingFacility",
    numeric: true,
    disablePadding: false,
    label: "CLIA",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
];


export const eicrMasterQueueHeadCells = [
  {
    id: "qaFlag",
    numeric: false,
    disablePadding: false,
    label: "",
  },
  {
    id: "transactionId",
    numeric: false,
    disablePadding: false,
    label: "Identifier",
  },
  {
    id: "msh10",
    numeric: true,
    disablePadding: false,
    label: "Message Control ID",
  },
  {
    id: "transactionReceivedDate",
    numeric: true,
    disablePadding: false,
    label: "Time Received",
  },
  {
    id: "transactionProcessedDate",
    numeric: true,
    disablePadding: false,
    label: "Time Processed",
  },
  {
    id: "sendingFacilityName",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility",
  },
  {
    id: "SendingFacilityidORcliaORoidORNPI",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility ID",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
];


export const eicrErrorQueueHeadCells = [
  {
    id: "qaFlag",
    numeric: false,
    disablePadding: false,
    label: "",
  },
  {
    id: "transactionId",
    numeric: false,
    disablePadding: false,
    label: "Identifier",
  },
  {
    id: "msh10",
    numeric: true,
    disablePadding: false,
    label: "Message Control ID",
  },
  {
    id: "transactionReceivedDate",
    numeric: true,
    disablePadding: false,
    label: "Time Received",
  },
  {
    id: "sendingFacilityName",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility",
  },
  {
    id: "SendingFacilityidORcliaORoidORNPI",
    numeric: true,
    disablePadding: false,
    label: "Sending Facility ID",
  },
  {
    id: "transactionError",
    numeric: true,
    disablePadding: false,
    label: "Error Type",
  },
];


export const unknownFacilityHeadCells = [
  {
    id: "errorCode",
    numeric: true,
    disablePadding: false,
    label: "Error Code",
  },
  {
    id: "type",
    numeric: true,
    disablePadding: false,
    label: "Error Type",
  },
  {
    id: "path",
    numeric: true,
    disablePadding: false,
    label: "Path",
  },
  {
    id: "codedErrorDetails",
    numeric: true,
    disablePadding: false,
    label: "Coded Error Details",
  },
];

export const snomedHeadCells = [
  {
    id: "snomedCode",
    numeric: true,
    disablePadding: false,
    label: "SNOMED Code",
  },
  {
    id: "secondarySnomed",
    numeric: false,
    disablePadding: false,
    label: "Secondary SNOMED",
  },
  {
    id: "conceptName",
    numeric: true,
    disablePadding: false,
    label: "Preferred Concept Name",
  },
  {
    id: "conditionName",
    numeric: false,
    disablePadding: false,
    label: "Master Condition",
  },
  {
    id: "snomedType",
    numeric: false,
    disablePadding: false,
    label: "SNOMED Type",
  },
  {
    id: "codeSystem",
    numeric: true,
    disablePadding: false,
    label: "Code System",
  },
  {
    id: "result",
    numeric: true,
    disablePadding: false,
    label: "Ordinal Result",
  },
  {
    id: "isActive",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "comments",
    numeric: true,
    disablePadding: false,
    label: "Admin Comments",
  },
];

export const userRoleManagementHeadCells = [
  {
    id: "user",
    numeric: true,
    disablePadding: false,
    label: "User",
  },
  {
    id: "roles",
    numeric: false,
    disablePadding: false,
    label: "Role",
  },
  {
    id: "isActive",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "dateActivated",
    numeric: true,
    disablePadding: false,
    label: "Date Activated",
  },
  {
    id: "dateDeActivated",
    numeric: true,
    disablePadding: false,
    label: "Date Deactivated",
  },
];

export const rolesAndPermissionsManagement = [
  {
    id: "roleName",
    numeric: true,
    disablePadding: false,
    label: "Role Name",
  },
  {
    id: "roleDescription",
    numeric: false,
    disablePadding: false,
    label: "Description",
  },
  {
    id: "isActive",
    numeric: true,
    disablePadding: false,
    label: "Status",
  }
];

export const conditionsHeadCells = [
  {
    id: "conditionName",
    numeric: true,
    disablePadding: false,
    label: "Condition Name",
  },
  {
    id: "eventCode",
    numeric: true,
    disablePadding: false,
    label: "Event Code",
  },
  {
    id: "diseaseKey",
    numeric: true,
    disablePadding: false,
    label: "Disease Key",
  },
  {
    id: "programArea",
    numeric: true,
    disablePadding: false,
    label: "Program Area",
  },
  {
    id: "parentCondition",
    numeric: true,
    disablePadding: false,
    label: "Parent Condition",
  },
  {
    id: "createdOn",
    numeric: true,
    disablePadding: false,
    label: "Created On",
  },
  {
    id: "isActive",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "comments",
    numeric: true,
    disablePadding: false,
    label: "Admin Comments",
  },
];

export const facilitiesHeadCells = [
  {
    id: "sendingFacilityName",
    numeric: false,
    disablePadding: false,
    label: "Facility Name",
  },
  {
    id: "parentOrganization",
    numeric: true,
    disablePadding: false,
    label: "Parent Organization",
  },
  {
    id: "sendingFacilityIdentifier",
    numeric: true,
    disablePadding: false,
    label: "Facility ID",
  },
  {
    id: "sendingFacilityType",
    numeric: true,
    disablePadding: false,
    label: "Facility Type",
  },
  {
    id: "city",
    numeric: true,
    disablePadding: false,
    label: "City",
  },
  {
    id: "state",
    numeric: true,
    disablePadding: false,
    label: "State",
  },
  {
    id: "dataType",
    numeric: true,
    disablePadding: false,
    label: "Data Type",
  },
  {
    id: "isActive",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
];

export const perfFacilitiesHeadCells = [
  {
    id: "performingFacilityName",
    numeric: false,
    disablePadding: false,
    label: "Facility Name",
  },
  {
    id: "clia",
    numeric: true,
    disablePadding: false,
    label: "CLIA",
  },
  {
    id: "addressLine1",
    numeric: true,
    disablePadding: false,
    label: "Street Address",
  },
  {
    id: "city",
    numeric: true,
    disablePadding: false,
    label: "City",
  },
  {
    id: "state",
    numeric: true,
    disablePadding: false,
    label: "State",
  },
  {
    id: "zip",
    numeric: true,
    disablePadding: false,
    label: "Zip",
  },
  {
    id: "phoneNo",
    numeric: true,
    disablePadding: false,
    label: "Phone Number",
  },
  {
    id: "isActive",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
];

export const rulesHeadCells = [
  {
    id: "ruleId",
    numeric: true,
    disablePadding: false,
    label: "Rule ID",
  },
  {
    id: "ruleName",
    numeric: true,
    disablePadding: false,
    label: "Rule Name",
  },
  {
    id: "ruleCategory",
    numeric: true,
    disablePadding: false,
    label: "Rule Type",
  },
  {
    id: "sendingFacilityNames",
    numeric: true,
    disablePadding: false,
    label: "Facility",
  },
  {
    id: "isActive",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "ruleDescription",
    numeric: true,
    disablePadding: false,
    label: "Description",
  },
];

export const errorMessageHeadCells = [
  {
    id: "errorCode",
    numeric: true,
    disablePadding: false,
    label: "Error Code",
  },
  {
    id: "errorType",
    numeric: true,
    disablePadding: false,
    label: "Error Type",
  },
  {
    id: "errorPath",
    numeric: true,
    disablePadding: false,
    label: "Path",
  },
  {
    id: "errorDescription",
    numeric: true,
    disablePadding: false,
    label: "Coded Error Details",
  },
  {
    id: "errorComments",
    numeric: true,
    disablePadding: false,
    label: "Incorrect Values",
  },
];

export const reportsHeadCells = [
  {
    id: "reportName",
    numeric: true,
    disablePadding: false,
    label: "Report Name",
  },
  {
    id: "description",
    numeric: true,
    disablePadding: false,
    label: "Description",
  },
];

export const reportingLoincsHeadCells = [
  {
    id: "performingFacilityName",
    numeric: true,
    disablePadding: false,
    label: "Facility Name",
  },
  {
    id: "reportingLoincCode",
    numeric: true,
    disablePadding: false,
    label: "Reporting LOINC",
  },
];

export const reportingLoincCodesHeadCells = [
  {
    id: "reportingLoincCode",
    numeric: true,
    disablePadding: false,
    label: "Reporting LOINC",
  },
  {
    id: "loincCode",
    numeric: true,
    disablePadding: false,
    label: "Standard LOINC",
  },
  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "Description",
  },
  {
    id: "performingFacilityName",
    numeric: true,
    disablePadding: false,
    label: "Performing Facility Name",
  },
  {
    id: "clia",
    numeric: false,
    disablePadding: false,
    label: "CLIA",
  },
  {
    id: "isActive",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "qnInterpretation",
    numeric: true,
    disablePadding: false,
    label: "Qn Interpretation",
  },
];

export const auditLogHeadCells = [
  {
    id: "userName",
    numeric: true,
    disablePadding: false,
    label: "Username",
  },
  {
    id: "firstName",
    numeric: false,
    disablePadding: false,
    label: "First Name",
  },
  {
    id: "lastName",
    numeric: true,
    disablePadding: false,
    label: "Last Name",
  },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
  {
    id: "createdDate",
    numeric: true,
    disablePadding: false,
    label: "Time Stamp",
  },
];

export const transactionLogHeadCells = [
  {
    id: "transactionId",
    numeric: true,
    disablePadding: false,
    label: "Message ID",
  },
  {
    id: "created",
    numeric: false,
    disablePadding: false,
    label: "Username",
  },
  {
    id: "source",
    numeric: true,
    disablePadding: false,
    label: "Description",
  },
  {
    id: "createdDate",
    numeric: true,
    disablePadding: false,
    label: "Time Stamp",
  },
];
